import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('errorPage.notFound')}
      extra={
        <Button type="primary" size="large" href="/">
          {t('errorPage.backToTop')}
        </Button>
      }
    />
  );
}
